import { produce } from 'immer';

export interface CallbackHistoryItem {
  undo: () => void;
  redo: () => void;
}

export interface CallbackHistory {
  stack: CallbackHistoryItem[];
  current: number;
}

export const emptyCallbackHistory = {
  stack: [],
  current: 0,
};

export function addHistoryItem(
  history: CallbackHistory,
  item: CallbackHistoryItem,
): CallbackHistory {
  return produce(history, (draft) => {
    if (draft.current < draft.stack.length) {
      draft.stack.splice(draft.current);
    }
    draft.stack.push(item);
    draft.current += 1;
  });
}

export function callUndo(history: CallbackHistory): CallbackHistory {
  if (!canUndo(history)) {
    return history;
  }

  return produce(history, (draft) => {
    draft.current -= 1;
    // Fixed noUncheckedIndexedAccess NIM-19408
    draft.stack[draft.current]!.undo();
  });
}

export function callRedo(history: CallbackHistory): CallbackHistory {
  if (!canRedo(history)) {
    return history;
  }

  // Fixed noUncheckedIndexedAccess NIM-19408
  history.stack[history.current]!.redo();
  return produce(history, (draft) => {
    draft.current += 1;
  });
}

export function canUndo(history: CallbackHistory): boolean {
  return history.current > 0;
}

export function canRedo(history: CallbackHistory): boolean {
  return history.current < history.stack.length;
}
